export const SET_SHOW_DETAILS = 'SET_SHOW_DETAILS';
